/* eslint-disable jsx-a11y/img-redundant-alt */
import skillJavaScript from "../assets/img/skillJavaScrpit.png";
import skillKotlin from "../assets/img/skillKotlin.png";
import skillReact from "../assets/img/skillReact.png";
import skillCSS from "../assets/img/skillCSS.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>Algumas de minhas skills<br></br>E vou continuar estudando para me tornar um Desenvolvedor Full Stack</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={skillJavaScript} alt="Image" />
                                <h5>JavaScript</h5>
                            </div>
                            <div className="item">
                                <img src={skillKotlin} alt="Image" />
                                <h5>Kotlin</h5>
                            </div>
                            <div className="item">
                                <img src={skillReact} alt="Image" />
                                <h5>React</h5>
                            </div>
                            <div className="item">
                                <img src={skillCSS} alt="Image" />
                                <h5>HTML</h5>
                            </div>
                            <div className="item">
                                <img src={skillCSS} alt="Image" />
                                <h5>CSS</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
